import React from "react";
import { SwitchRoute } from "../../../Components/Route/SwitchRoute";
import { ActiveUserLogRoutes } from "../../../routes";

export const ActiveUserLog = (props) => {
  return <SwitchRoute routes={ActiveUserLogRoutes} />;
};
